module.exports = __webpack_public_path__ + "static/media/ic_check_circle2.777f7d8d.svg";